// import Shape from '../../assets/img/testimonial/testi-item-shape-1.png';
// import Image from '../../assets/img/testimonial/testi-1.png';

// const SingleTestimonial = (props) => {
//   const { itemClass, shapeImg, authorImg, Name, Designation, Description } =
//     props;
//   return (
//     <div
//       className={
//         itemClass
//           ? itemClass
//           : 'testimonial__item d-flex justify-content-betweena align-items-center p-relative'
//       }
//     >
//       <div className="testimonial__item-shape">
//         <img src={shapeImg ? shapeImg : Shape} alt="" />
//       </div>
//       <div className="testimonial__content">
//         <div className="testimonial__author-info">
//           <h5 className="testimonial__author-name">
//             {Name ? Name : 'Karon Rubel'}
//           </h5>
//           <span>{Designation ? Designation : 'Founder'}</span>
//         </div>
//         <div className="testimonial__content-text">
//           <p>
//             {Description
//               ? Description
//               : 'We are privileged to work with hundreds future businesses, including many of the world’s software, and brands.'}
//           </p>
//           <i className="fas fa-star"></i>
//           <i className="fas fa-star"></i>
//           <i className="fas fa-star"></i>
//           <i className="fas fa-star"></i>
//           <i className="fas fa-star star-color"></i>
//         </div>
//       </div>
//       <div className="testimonial__main-img">
//         <img src={authorImg ? authorImg : Image} alt="" />
//       </div>
//     </div>
//   );
// };

// export default SingleTestimonial;
import React from "react";
import Shape from "../../assets/img/testimonial/testi-item-shape-1.png";

const SingleTestimonial = (props) => {
  const { itemClass, shapeImg, Name, Designation, Description } = props;

  // Generate placeholder avatar based on name
  const generateInitials = (name) => {
    if (!name) return "KR";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  // Generate random background color based on name
  const getBackgroundColor = (name) => {
    if (!name) return "#4f5ff6";
    const colors = [
      "#4f5ff6",
      "#f65f4f",
      "#4ff6a0",
      "#f6c24f",
      "#9a4ff6",
      "#f64fa8",
      "#4fc3f6",
      "#8bf64f",
    ];
    const hash = name
      .split("")
      .reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    return colors[hash % colors.length];
  };

  const initials = generateInitials(Name);
  const bgColor = getBackgroundColor(Name);

  return (
    <div
      className={
        itemClass
          ? itemClass
          : "testimonial__item d-flex justify-content-betweena align-items-center p-relative"
      }
    >
      <div className="testimonial__item-shape">
        <img src={shapeImg ? shapeImg : Shape} alt="" />
      </div>
      <div className="testimonial__content">
        <div className="testimonial__author-info">
          <h5 className="testimonial__author-name">
            {Name ? Name : "Karon Rubel"}
          </h5>
          <span>{Designation ? Designation : "Founder"}</span>
        </div>
        <div className="testimonial__content-text">
          <p>
            {Description
              ? Description
              : "We are privileged to work with hundreds future businesses, including many of the world software, and brands."}
          </p>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
          <i className="fas fa-star"></i>
        </div>
      </div>
      <div
        className="testimonial__main-img"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          backgroundColor: bgColor,
          color: "white",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        {initials}
      </div>
    </div>
  );
};

export default SingleTestimonial;
